<!-- Custom System Message for new user. Shown after pressing 'Next' on associate inventory page -->
<div
    id="system-messages-wrapper"
    [@visibilityChanged]="showNewUserMessage"
    (@visibilityChanged.start)="displayMessage = 'block'"
    (@visibilityChanged.done)="displayMessage = showNewUserMessage ? 'block' : 'none'"
    [style.display]="displayMessage"
    [ngStyle]="getCenteredStyles()"
    (click)="closeSystemMessage()"
>
    <div class="{{ firstLoad ? '' : 'd-none' }}">
        <span aria-hidden="true" id="sys-message-closer"> X </span>
        <div role="alert" aria-live="polite" aria-atomic="true" id="system-messages" class="success">
            <span id="sys-message-header">User Successfully Created!</span>
            User Created Successfully! If you'd like the user to access EMIT right now,
            <button type="button" (click)="resetPassword(true, true)" class="btn btn-save btn-sm">
                Send Welcome Email
            </button>
            or if you have more users to create, click
            <a class="btn btn-save btn-sm" href="/users/edit/details/0">HERE</a>
            <br />
        </div>
    </div>
</div>

<div class="section-ctnr">
    <form pcgSubmitUrl="api/Administration/Users/SaveUser" (messageReceive)="saveUser($event)" [formGroup]="formGroup">
        <div>
            <div class="row descriptionWrapping mb-4 mt-2">
                <div class="col-md-12">
                    <pcg-dual-list-box
                        [disabled]="!canManageUsers"
                        class="listBox"
                        leftHeader="Sites List"
                        rightHeader="Associated Sites"
                        [source]="allSites"
                        [destination]="associatedSites"
                        (click)="handleFormGroup()"
                    ></pcg-dual-list-box>
                </div>
            </div>

            <pcg-fixed-buttons>
                @if ((!isCurrentUser || canManageUsers) && !model.isNewUser) {
                    <a class="btn btn-cancel btn-lg" backButton="/users/list">Back</a>
                }
                @if ((!isCurrentUser || canManageUsers) && model.isNewUser) {
                    <a class="btn btn-cancel btn-lg" (click)="handleBackAssociate()">Back</a>
                }
                @if (id !== 0 && !model.isNewUser && !isCreatingNewUser) {
                    <button class="btn btn-save btn-lg">Save</button>
                }
                @if (id !== 0 && isCreatingNewUser && !isCurrentUser) {
                    <button class="btn btn-save btn-lg">Next</button>
                }
            </pcg-fixed-buttons>
        </div>
    </form>
</div>
